module.exports = __webpack_public_path__ + "static/media/nutrition-diet-eating.71196c01.png";